import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaUnlock } from './useMediaUnlock';
/**
 * 프로브 실패 시에만 상·하 스트랩. 중앙 딤/모달 금지.
 * hit-area는 투명 전체 — OBS Interact 창에서 클릭하기 쉽게.
 */
function MediaUnlockStrap({ message = '클릭해서 소리를 켜 주세요' }) {
    const { showStrap, requestUnlock } = useMediaUnlock();
    if (!showStrap)
        return null;
    return (_jsxs("div", { "data-overlay": "media-unlock-strap", role: "button", tabIndex: 0, "aria-label": message, onClick: requestUnlock, onKeyDown: (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                requestUnlock();
            }
        }, style: {
            position: 'fixed',
            inset: 0,
            zIndex: 2147483646,
            cursor: 'pointer',
            background: 'transparent',
        }, children: [_jsx("div", { "aria-hidden": true, style: {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    background: 'rgba(0, 0, 0, 0.72)',
                    color: '#fff',
                    fontSize: 16,
                    fontFamily: 'system-ui, sans-serif',
                    textAlign: 'center',
                    pointerEvents: 'none',
                }, children: message }), _jsx("div", { "aria-hidden": true, style: {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px 16px',
                    background: 'rgba(0, 0, 0, 0.72)',
                    color: '#fff',
                    fontSize: 16,
                    fontFamily: 'system-ui, sans-serif',
                    textAlign: 'center',
                    pointerEvents: 'none',
                }, children: message })] }));
}
export { MediaUnlockStrap };
//# sourceMappingURL=MediaUnlockStrap.js.map